"use client";

import * as React from "react";

export function useChartScale(defaultLog = true) {
  const [logScale, setLogScale] = React.useState(defaultLog);
  return { logScale, setLogScale };
}
